export var REALNAME_CANCEL = 'REALNAME_CANCEL';
export var CUSTOMS_VERIFY = 'CUSTOMS_VERIFY';
export var NOTIFICATION_FUNCTIONCODE = 'NOTIFICATION_FUNCTIONCODE';
